import { Visibility } from '@mui/icons-material';
import { Table, TableCell, TableHead, TableRow, TableBody, TableContainer, Paper, IconButton, Box } from '@mui/material';
import { SnakeLoader } from '../../../../core/loader/SnakeLoader';
import { NothingToSee } from '../../empty/Index';
import moment from 'moment';
import { Waypoint } from 'react-waypoint';

const List = ({list, listLoader, setForm, setAdd, hasMore, loadMoreData, tool_state, totalList}) => {
    const { __SESSION } = tool_state
    const tableHeaders = [
        'No.',
        'Contact No.',
        'Company Name',
        'Email',
        'Contact Person',
        'Added By',
        'Date Added',
        'Source',
        'Status',
        'Action',
    ];

    const handlerView = (data) => {
        if (data) {
            setAdd(true)
            setForm((p) => (
                {...p, email: data.email, last_name: data.last_name, first_name: data.first_name, contact_no: data.mobile_number, birthdate: data.birthdate, company_name: data.company_name, address: data.address, method: 'view'}
            ))
        }
    }
    
    return(
        <>
            {
                listLoader ?
                    <Box width="100%" display="flex" justifyContent="center" alignItems="center" mt={2}>
                        <SnakeLoader size="14px" bg="#009F4D" distance="0.3rem" />
                    </Box>
                :
                    list.length === 0 ?
                        <NothingToSee text="No Available Training" />
                    :
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead sx={{backgroundColor: "#000"}}>
                                    <TableRow>
                                        {
                                            tableHeaders.map((d,k) => (
                                                <TableCell key={k} sx={{color: "#fff", fontWeight: "bold"}}>{d}</TableCell>
                                            ))
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {list.map((row, idx, data) => (
                                        <TableRow key={idx}>
                                            <TableCell>{totalList - idx}</TableCell>
                                            <TableCell>{row.mobile_number}</TableCell>
                                            <TableCell>{row.company_name}</TableCell>
                                            <TableCell>{row.email}</TableCell>
                                            <TableCell>{row.first_name} {row.last_name}</TableCell>
                                            <TableCell>
                                                {row.source === "Online Purchase" ? "Customer" : (
                                                    <>
                                                        {__SESSION?.data?.pinfo?.[0]?.first_name ?? ""} {__SESSION?.data?.pinfo?.[0]?.last_name ?? ""}
                                                    </>
                                                )}
                                            </TableCell>
                                            <TableCell>{moment(row.date_added).format("MM/DD/YYYY")}</TableCell>
                                            <TableCell>{row.source}</TableCell>
                                            <TableCell>{row.active === 1 ? "Active" : ""}</TableCell>
                                            <TableCell>
                                                <IconButton onClick={() => handlerView(row)}>
                                                    <Visibility  sx={{ color: '#81D4FA' }} />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            {
                                hasMore && (
                                    <Waypoint onEnter={loadMoreData}>
                                        <Box width="100%" display="flex" justifyContent="center" my={2}>
                                            <SnakeLoader bg="#009F4D" size= "10px" distance= "5px"  />
                                        </Box>
                                    </Waypoint>
                                )
                            }
                        </TableContainer>
            }
        </>
    )
}

export default List;    